/**
 * Полномочия prokat на фронте. Коды — те же, что в реестре сервера
 * (`app/core/modules/auth/permission/registry.py`); решает сервер, здесь только
 * не показываем то, в чём он откажет.
 */
import { useGetIdentity } from "@refinedev/core";

import type { CurrentUser } from "@/lib/providers";

export const PERMISSIONS_EDIT = "permissions_edit";
export const FOLLOWUP_RUN = "followup_run";
export const REQUESTS_VIEW = "requests_view";
export const CLIENT_CHATS = "client_chats";
export const EXT_JOURNAL = "ext_journal";
export const BONUS_ALL = "bonus_all";
export const SALARY_ALL = "salary_all";
export const SALARY_INDEX = "salary_index";
export const CHAT_SUGGEST = "chat_suggest";
export const CHAT_GROUPS = "chat_groups";
export const CHAT_GROUPS_EDIT = "chat_groups_edit";
export const ANNOTATE = "annotate";
export const CONTRACT_EDIT = "contract_edit";
export const PASSPORT_VIEW = "passport_view";
export const VIDEO_VIEW = "video_view";
export const KNOWLEDGE_EDIT = "knowledge_edit";
export const QC_REMARK = "qc_remark";
export const VOICE_LAB = "voice_lab";
export const ACTIVITY_CONTROL = "activity_control";
export const ACTIVITY_IDLE_NOTIFY = "activity_idle_notify";
export const ACCEPT_VIEW = "accept_view";
export type PermissionCode =
  | typeof PERMISSIONS_EDIT
  | typeof FOLLOWUP_RUN
  | typeof REQUESTS_VIEW
  | typeof CLIENT_CHATS
  | typeof EXT_JOURNAL
  | typeof BONUS_ALL
  | typeof SALARY_ALL
  | typeof SALARY_INDEX
  | typeof CHAT_SUGGEST
  | typeof CHAT_GROUPS
  | typeof CHAT_GROUPS_EDIT
  | typeof ANNOTATE
  | typeof CONTRACT_EDIT
  | typeof PASSPORT_VIEW
  | typeof VIDEO_VIEW
  | typeof KNOWLEDGE_EDIT
  | typeof QC_REMARK
  | typeof VOICE_LAB
  | typeof ACTIVITY_CONTROL
  | typeof ACTIVITY_IDLE_NOTIFY
  | typeof ACCEPT_VIEW;

export function has(user: CurrentUser | null | undefined, code: PermissionCode): boolean {
  return user?.permissions?.includes(code) ?? false;
}

/**
 * Есть ли право у вошедшего.
 *
 * Ответ ОКОНЧАТЕЛЬНЫЙ: каркас (`AppLayout`) не рисует экран, пока личность не
 * приехала, поэтому «нет» здесь значит «нет права», а не «ещё не знаем».
 */
export function useCan(code: PermissionCode): boolean {
  const { data } = useGetIdentity<CurrentUser>();
  return has(data, code);
}
